<template>
	<div>
		<!-- Add Insured -->
		<div class="flex xs-right xs-12 mb2 mt6">
			<j-button type="tertiary" @click="$modal.show('addInsured')">
				<crm-icon name="add" color="c2" />Add Insured
			</j-button>
		</div>

		<!-- List of Insured -->
		<div v-for="(insured, i) in insureds" :key="i" class="mb4">
			<core-entity-card
				:entity="insured"
				:hasActions="true"
				:pinnable="false"
				:isExpanded="false"
				@updated="refetchCase"
				@added="refetchCase"
				@deleted="refetchCase"
			>
				<!-- Header -->
				<div class="fs4 c1 pt3 pb3" slot="header">
					{{ $t("insured") }} {{ i + 1 }}
				</div>

				<!-- Footer -->
				<div class="flex xs-12 xs-right mt6" slot="footer">
					<!-- TODO: make it work -->
					<j-button
						type="error"
						size="small"
						@click="removeInsured(insured.id)"
					>
						<crm-icon name="delete" color="c5" class="mr2" />Remove
					</j-button>
				</div>
			</core-entity-card>
		</div>

		<!-- Modal -->
		<core-modal
			name="addInsured"
			headline="Select Entity"
			:pivotX="0"
			:pivotY="0"
			:hasHeader="false"
		>
			<div style="height:100vh; overflow: scroll;">
				<entity-picker @entity:selected="addInsured($event)" />
			</div>
		</core-modal>
	</div>
</template>

<script>
import JButton from "@/components/JButton"
import CrmIcon from "@/components/CrmIcon"
import CoreEntityCard from "@/modules/core/components/CoreEntityCard"
import CoreModal from "@/modules/core/components/CoreModal"
import EntityPicker from "../CaseForm/EntityPicker/EntityPicker"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: { JButton, CrmIcon, CoreEntityCard, CoreModal, EntityPicker },

	computed: {
		insureds() {
			const result = JSON.parse(
				JSON.stringify(this.$store.state.caseManagement?.case?.insureds || [])
			)
			return result
		}
	},

	methods: {
		refetchCase() {
			this.$store.dispatch("caseManagement/fetchCase", {
				caseId: this.$store.state.caseManagement.caseId
			})
		},

		async addInsured(payload) {
			this.$modal.hide("addInsured")

			const query = gql`
				mutation updateCase($id: String!, $input: updateCaseInput!) {
					updateCase(id: $id, input: $input) {
						status
						errors
					}
				}
			`

			const variables = {
				id: this.$store.state.caseManagement.caseId,
				input: {
					insuredIds: [
						...this.insureds?.map(insured => insured?.id),
						payload.id
					]
				}
			}

			const res = await api({ query, variables })

			if (res?.data?.updateCase?.status !== "success") {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text:
							res?.errors ||
							res?.data?.updateCase?.errors ||
							res?.data?.updateCase?.errors_2.message ||
							"Oops ! An error occured."
					}
				})
			}

			this.refetchCase()
		},

		async removeInsured(id) {
			// copy of insured that we want to remove
			const oldInsured = this.insureds?.find(item => item.id === id)

			// list of insureds - filtering out id of insured we want to remove
			const newInsureds = this.insureds
				?.filter(insured => insured?.id !== id)
				?.map(insured => insured?.id)

			// remove insured from store cache
			const stateFilter = function(state) {
				return state.case?.insureds
			}
			this.$store.commit("caseManagement/UPDATE_CASE", {
				actionType: "remove",
				fieldName: "id",
				value: id,
				stateFilter
			})

			const query = gql`
				mutation updateCase($id: String!, $input: updateCaseInput!) {
					updateCase(id: $id, input: $input) {
						status
						errors
					}
				}
			`

			const variables = {
				id: this.$store.state.caseManagement.caseId,
				input: {
					insuredIds: newInsureds
				}
			}

			const res = await api({ query, variables })

			if (res?.data?.updateCase?.status !== "success") {
				// add insured to store cache
				const stateFilter = function(state) {
					return state.case
				}
				// Update type
				this.$store.commit("caseManagement/UPDATE_CASE", {
					actionType: "push",
					fieldName: "insureds",
					value: oldInsured,
					stateFilter
				})
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text:
							res?.errors ||
							res?.data?.updateCase?.errors ||
							res?.data?.updateCase?.errors_2.message ||
							"Oops ! An error occured."
					}
				})
			}

			this.refetchCase()
		}
	}
}
</script>
